module.exports = __webpack_public_path__ + "img/notification_icon.2b4bb706.svg";